export const anchorScroll = (e, id) => {
  const el = id && document.getElementById(id);
  if (!el) return;
  if (e) e.preventDefault();
  if (window.__lenis)
    window.__lenis.scrollTo(el, {
      offset: -72,
      duration: 1.5,
      easing: (t) => 1 - Math.pow(1 - t, 4),
    });
  else el.scrollIntoView({ behavior: "smooth" });
};

// Touch devices get the one-tap call; mouse devices scroll to the callback form.
export const isTouch = () =>
  window.matchMedia && window.matchMedia("(pointer: coarse)").matches;

export const ctaGo = (e) => {
  if (isTouch()) return;
  anchorScroll(e, "contact");
};

export default anchorScroll;
